export default function CardHeader(props) {
  return <div className="card-header">{props.children}</div>;
}
